import { actionOrchestrator } from '@/business/orchestrator/ActionOrchestrator';
import { Action } from '@/business/types/action.types';
import { ResponseCode } from '@/business/types/response-codes.types';

export class QueryError extends Error {
  constructor(
    public readonly code: ResponseCode,
    public readonly action: Action
  ) {
    super(`Query failed: ${action} (code: ${code})`);
    this.name = 'QueryError';
  }
}

export async function executeQuery<TInput, TOutput>(
  action: Action,
  data: TInput
): Promise<TOutput> {
  const result = await actionOrchestrator.execute<TInput, TOutput>(
    action,
    data
  );
  if (result.code !== ResponseCode.SUCCESS || result.data === undefined) {
    throw new QueryError(result.code, action);
  }
  return result.data;
}
